import $ from 'jquery';
import { onAddLogoToCanvas } from '~src/image';
import { getState } from '~src/state';

export const displaySidebarLogos = async () => {
  const sidebarLogos = getState('sidebarLogos', { items: [] });
  if (sidebarLogos.items.length === 0) {
    $('#editor-sidebar-upload-btn-logo').text('Carica');
    const html = `<div class="containerTextEmptyBox" id="containerTextEmptyBoxLogo"
                    <div class="textEmptyBox">Non ci sono loghi
                    </div>
                  </div>`;
    $('#editor-sidebar-logo').html(html);
    return;
  }
  $('#editor-sidebar-upload-btn-logo').text('Sostituisci');

  // Raggruppa gli item per ruolo/entità, mantenendo l'ordine org -> company -> office
  // prodotto da fetchLogos.
  const groups = [];
  const groupsByKey = {};
  for (const item of sidebarLogos.items) {
    const groupKey = `${item.ownerType}:${item.ownerId}`;
    if (!groupsByKey[groupKey]) {
      groupsByKey[groupKey] = { label: item.ownerLabel, items: [] };
      groups.push(groupsByKey[groupKey]);
    }
    groupsByKey[groupKey].items.push(item);
  }

  const ids = [];
  let html = '';
  let index = 0;

  for (const group of groups) {
    html += `<div class="sidebar-logos-group-title">${group.label}</div>`;

    for (const item of group.items) {
      const itemId = `editor-sidebar-add-logo-${index++}`;

      html += `<div class="sidebar-item-grid-box image-square-container sidebar-logo-card">
                  <div
                    id="${itemId}"
                    data-url="${item.url}"
                    data-logo-type="${item.logoType}"
                    data-owner-type="${item.ownerType}"
                    class="sidebar-item-grid-box-click-listener"
                  ></div>
                  <img
                      src="../assets/svg/img-loader.gif"
                      class="lazy image-square"
                      data-src="${item.url}"
                  />
                  <div class="sidebar-logos-variant-label">${item.variantLabel}</div>
              </div>`;

      ids.push(`#${itemId}`);
    }
  }

  if (ids.length) {
    ids.forEach((id) => {
      $('body').off('click', id, onAddLogoToCanvas);
      $('body').on('click', id, onAddLogoToCanvas);
    });
  }

  $('#editor-sidebar-logo').html(html);
  window.lazyLoadInstance.update();
};
